<footer class="footer">
  <div class="footer-links">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg">
          <app-block identifier="footer_links1"></app-block>
        </div>

        <div class="col-12 col-lg">
          <app-block identifier="footer_links2"></app-block>
        </div>

        <div class="col-12 col-lg">
          <app-block identifier="footer_links3"></app-block>
        </div>

        <div class="col-12 col-lg">
          <app-block identifier="footer_links4"></app-block>
        </div>

        @if (!isNewsletterActive) {
          <div class="col-12 col-lg">
            <app-block identifier="footer_links5"></app-block>
          </div>
        }

        @if (isNewsletterActive) {
          <div class="col-12 col-lg">
            <app-newsletter></app-newsletter>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col col-12">
          {{ copyright }}
        </div>
      </div>
    </div>
  </div>
</footer>

@if (showButton) {
  <button
    class="btn-scroll-top"
    (click)="scrollTop()"
    title="{{ 'Scroll to top' | translate | async }}"
  >
    <mat-icon>keyboard_arrow_up</mat-icon>
  </button>
}
